import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "./components/AppHeader";

const CanvasInstructions = () => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false); // Canvas button
  const [showGenerateConfirm, setShowGenerateConfirm] = useState(false);
  const [showExitConfirm, setShowExitConfirm] = useState(false);

  const handleProceed = () => {
    window.open(
      "https://canvas.sfsu.edu/",
      "CanvasWindow",
      "noopener,noreferrer,width=1200,height=800"
    );
    setShowConfirm(false);
  };

  return (
    <div className="min-h-screen bg-secondary font-sans">
      <AppHeader titleSize="text-3xl" bgClass="bg-primary" textClass="text-white" />

      <div className="bg-accent text-center py-3">
        <h2 className="text-2xl font-bold text-primary underline">
          Directions for importing questions into Canvas
        </h2>
      </div>

      <div className="p-6 text-gray-800 space-y-4 max-w-2xl mx-auto mt-8 bg-white rounded shadow">
        <h3 className="text-2xl font-semibold text-indigo-700">
          📅 Please follow below steps:
        </h3>
        <ol className="list-decimal pl-6 space-y-2 text-left">
          <li>
            Log in to{" "}
            <button
              type="button"
              className="text-blue-600 underline"
              onClick={() =>
                window.open(
                  "https://canvas.sfsu.edu/",
                  "CanvasWindow",
                  "noopener,noreferrer,width=1200,height=800"
                )
              }
            >
              Canvas
            </button>
            {" "}
            and open the course to which you want to import the new questions.
          </li>
          <li>From the Course Home Page, select "Import Existing Content" from the top right corner of the page.</li>
          <li>In the Content Type dropdown, select QTI .zip file.</li>
          <li>Under Source, upload the QTI file from your computer that you exported from DeepToast.</li>
          <li>In the Default Question Bank dropdown, select an existing question bank to which you want to add the questions, or select "Create new question bank" if you want to create a new one.
          </li>
          <li>If creating a new question bank, enter a name for the question bank*</li>
          <li>Wait until the import status shows Import Complete.</li>
          <li>Navigate to Quizzes → click the three-dot menu (⋮) → select Manage Question Banks.</li>
          <li>Open the newly created question bank.</li>
          <li>Click the pencil (edit) icon and retype your chosen question bank name.</li>
        </ol>

        <p className="italic font-semibold text-black-700 underline mt-4">
          * As of Spring 2026, Canvas is not taking the question bank name as input provided by the user. A workaround for this is provided in steps 8 to 10. For ease of use, you should print this page.
        </p>

        <div className="flex flex-nowrap justify-between gap-4">
          <button
            onClick={() => setShowConfirm(true)}
            className="bg-green-600 text-white px-4 py-2 text-base font-semibold rounded hover:bg-green-700 w-52 h-16 flex items-center justify-center text-center"
          >
            Go to Canvas to import text file(s)
          </button>

          <button
            onClick={() => navigate("/")}//setShowGenerateConfirm(true)}
            className="bg-indigo-600 text-white px-4 py-2 text-base font-semibold rounded hover:bg-indigo-700 w-52 h-16 flex items-center justify-center text-center"
          >
            🔄 Generate More Questions
          </button>

          <button
            onClick={() => setShowExitConfirm(true)}
            className="bg-gray-700 text-white px-4 py-2 text-base font-semibold rounded hover:bg-gray-800 w-52 h-16 flex items-center justify-center text-center"
          >
            ❌ Exit DeepToast
          </button>
        </div>
      </div>

      {/* Canvas Confirm Dialog */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full text-center space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">
              This will open Canvas in a new window.
            </h3>
            <p className="text-gray-600">
              You can click on this tab to come back and view instructions. Do you want to proceed?
            </p>
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={handleProceed}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Yes, open Canvas
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                No, stay here
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Generate More Questions Confirm */}
      {/* {showGenerateConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full text-center space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Are you sure you want to generate more questions?
            </h3>
            <p className="text-gray-600">
              You haven’t imported your current questions. 
            </p>
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={() => {
                  setShowGenerateConfirm(false);
                  navigate("/");
                }}
                className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
              >
                Yes, continue
              </button>
              <button
                onClick={() => setShowGenerateConfirm(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                No, go back
              </button>
            </div>
          </div>
        </div>
      )} */}

      {/* Exit DeepToast Confirm */}
      {showExitConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full text-center space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Are you sure you want to exit DeepToast?
            </h3>
            {/* <p className="text-gray-600">
              Your questions haven’t been imported to Canvas.
            </p> */}
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={() => {
                  setShowExitConfirm(false);
                  navigate("/exit");
                }}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              >
                Yes, Exit
              </button>
              <button
                onClick={() => setShowExitConfirm(false)}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CanvasInstructions;
